import React, { useRef, useState } from 'react';

import { useAppStore } from '../../store/useAppStore';
import { uploadFile, downloadFile } from '../../api';
import { useTranslations } from '../../hooks/useTranslations';

const FilePicker = () => {
  const {
    // Session
    setSessionData,
    setInitialData,
    currentSessionId,
    createSession,

    addOriginalToHistory,

    loading,
    setLoading,

  } = useAppStore();

  const { t } = useTranslations();
  const fileInputRef = useRef(null);


  // Drag & Drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('drag-over');
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove('drag-over');
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileUpload(files[0]);
    }
    e.currentTarget.classList.remove('drag-over');
  };

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  const handleFileUpload = async (file) => {
    try {
      await setLoading(true)
      console.log('Uploading file:', file.name);
      const uploaded = await uploadFile(file)

      // Check if we have an active session
      if (!currentSessionId) {
        console.log('❌ No active session. Creating a new session.');
        await createSession(uploaded.container)
      } else {
        await setInitialData(uploaded.container)
      }
      
      console.log('uploaded',uploaded);

      const result = await setSessionData(uploaded.parts.at(-1), null)

      const image = await downloadFile(uploaded.parts.at(-1), null)
      await addOriginalToHistory(image)

      console.log('File uploaded successfully:', result);
      await setLoading(false)
    } catch (error) {
      console.error('Upload error:', error);
      alert('Upload error. Please try again.');
      await setLoading(false)
    }
  };

  return (
    <div className="welcome-message">
      <div 
        className="welcome-upload-area"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onClick={handleFileClick}
      >
        <i className="fas fa-eye"></i>
        <h2>Your AI Visual Agent</h2>
        <h3>More than words</h3>
        <p>Drop your image here and start creating with AI</p>
      <div className="upload-subtitle">
        <span>Transform • Enhance • Create</span>
      </div>
        <input 
          type="file" 
          accept="image/*" 
          style={{ display: 'none' }} 
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </div>
      {/* Processing overlay shown while backend is working */}
      {loading && (
        <div className="processing-overlay" role="status" aria-live="polite">
          <div className="spinner" />
          <span>Processing…</span>
        </div>
      )}
    </div>
  );
};

export default FilePicker; 